import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfigBankPopupComponent } from '../config-bank-inquiry/config-bank-popup/config-bank-popup.component';
import { ConfirmPopupComponent } from '../confirm-popup/confirm-popup.component';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service'
import { FeeRateManagePopupComponent } from './fee-rate-manage-popup/fee-rate-manage-popup.component';
import { Router } from '@angular/router';
import { AppMenuService } from 'app/business/service/app/app-menu.service';
import { AppUserService } from 'app/business/service/app/app-user.service';
import { ConfirmDialogService } from '@bundle/component/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-fee-rate-manage-inquiry',
  templateUrl: './fee-rate-manage-inquiry.component.html',
  styleUrls: ['./fee-rate-manage-inquiry.component.css']
})
export class FeeRateManageInquiryComponent implements OnInit, AfterViewInit {
  BenefitTarget: any = [];
  form: any = {};
  BenefitTargetValue: string;
  displayedColumns: string[] = ['code', 'name', 'val', 'feeunit', 'action'];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  url: any;
  buttonList: any[] = [];
  itemList: any[];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
    private alertMessageService: AlertMessageService,
    private confirmDialogService: ConfirmDialogService,
    private router: Router,
    private appMenuService: AppMenuService,
    private appUserService: AppUserService,
  ) { }

  async getRouter(): Promise<void> {
    
    this.url = this.router.url;

    const profile = JSON.parse(this.appUserService.getSessionUserProfile());
    const formData = {
      url: this.url,
      userGroupCode: profile?.userGroupCode,
      userRoleCode: profile?.userRoleCode,
      userCode: profile?.userCode
    };
    this.buttonList = await this.appMenuService.getButtonPermissionPerPages(formData);
    
  }

  async ngOnInit() {
    await this.getRouter();
    this.BenefitTarget = [{ benefitTargetCode: 1, benefitTargetTName: '10' }, { benefitTargetCode: 2, benefitTargetTName: '20' }];
    this.form.isActive = 'A';

    this.buttonList.forEach(e => {
      if (e.buttonCode === "BT089") {
        this.displayedColumns.unshift("select");
      }
    });

    this.loadData();
  }
  loadData() {
    const data = {
      "feeCode": this.form.feeCode,
      "feeDescription": this.form.feeDescription,
      "feeType": this.form.feeType
    };

    this.appMasterService.getMasterFeeRateList(data).then(res => {
      if (res === "error") {
        return;
      } else {
        this.itemList = res;
        this.dataSource = new MatTableDataSource(res)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
      }
    })
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  selectionPercent() {

  }
  editItem(e) {
    const data = {
      e: { ...e },
      buttonList: this.buttonList
    };
    const dialogRef = this.dialog.open(FeeRateManagePopupComponent, {
      disableClose: false,
      width: '60vw',
      data: data,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.loadData();
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filterValue?.length > 0) {
      var res = this.itemList.filter(e => (e.code.toLowerCase().includes(filterValue) || e.name.toLowerCase().includes(filterValue) || e.feeunit.toLowerCase().includes(filterValue)));

      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } else {
      this.dataSource = new MatTableDataSource(this.itemList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  formatCurrency(value: number) {
    return new Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      currencyDisplay: "code",
    })
      .format(value)
      .replace("THB", "")
      .trim();
  }

  save() {

  }

  addAccount(data): void {
    const d = {
      e: null,
      buttonList: this.buttonList
    };
    const dialogRef = this.dialog.open(FeeRateManagePopupComponent, {
      disableClose: false,
      width: '60vw',
      data: d,
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadData();
      }
      this.selection.clear(true);
    });
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  delete(e) {
    this.confirmDialogService.open({ header: "", content: "คุณต้องการลบข้อมูลนี้หรือไม่?" }).then(res => {
      if (res) {
        const data = {
          id: e.id,
          code: e.code,
          name: e.name,
          val: e.val,
          feeunit: e.feeunit,
          type: e.type,
          isActive: "N"
        };

        this.appMasterService.saveFee(data).then((res: any) => {
          if (res === "error") {
            return;
          } else {
            this.loadData();
          }
        });
      }
    });
  }

  deleteSelection() {
    if (this.selection?.selected?.length > 0) {
      this.confirmDialogService.open({ header: "", content: "คุณต้องการลบข้อมูลนี้หรือไม่?" }).then(res => {
        if (res) {
          var selectedKey = this.selection.selected.map((item, index, chats) => {
            return {
              id: item.id,
              code: item.code,
              name: item.name,
              val: item.val,
              feeunit: item.feeunit,
              type: item.type,
              isActive: "N"
            }
          });

          const req = {
            saveList: selectedKey
          };

          this.appMasterService.updateFeeBatch(req).then(res => {
            if (res === 'error') {
              this.alertMessageService.open({ message: "เกิดข้อผิดพลาดระหว่างบันทึกข้อมูล", title: "ข้อผิดพลาด" });
            } else {
              this.selection.clear(true);
              this.loadData();
            }
          });
        }
      });
    } else {
      this.alertMessageService.open({ message: "กรุณาเลือกรายการที่จะลบข้อมูล", title: "ข้อผิดพลาด" });
    }
  }
  checkButton(buttonCode: string) {
    var checkBtn = this.buttonList.find(e => e.buttonCode == buttonCode);

    if (checkBtn != undefined) {
      return true;
    } else {
      return false;
    }
  }
}
